var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.$t("billingDetails"),
      hideRgtBtn: true,
      outsideScrollToBottom: _vm.outsideScrollToBottom,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c("BillingTransactionTable", {
              attrs: {
                outsideScrollToBottom: _vm.popupToBottom,
                tenantKey: _vm.tenantKey,
                warehouseKey: _vm.warehouseKey,
                isClientModelLabel: Boolean(
                  _vm.client && (_vm.client.apiKey || _vm.client.orgKey)
                )
              }
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14c36c12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c36c12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BillingDetails.vue
// module id = null
// module chunks = 